"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _ = require("..");

var _Box = _interopRequireDefault(require("../Box"));

var __jsx = _react["default"].createElement;

/**
 * Button Raw
 */
var buttonResetStyles = {
  border: "none",
  margin: 0,
  padding: 0,
  width: "auto",
  overflow: "visible",
  background: "transparent",
  color: "inherit",
  font: "inherit",
  lineHeight: "normal",
  fontSmooth: "inherit",
  appearance: "none",
  ":not(:disabled)": {
    cursor: "pointer"
  },
  textAlign: "left"
};

function ButtonRaw_(props) {
  var sx = props.sx,
      buttonRef = props.buttonRef,
      restProps = (0, _objectWithoutProperties2["default"])(props, ["sx", "buttonRef"]);

  var _splitSx = (0, _.splitSx)(sx),
      _splitSx2 = (0, _slicedToArray2["default"])(_splitSx, 2),
      css = _splitSx2[0],
      customSx = _splitSx2[1];

  return (0, _.jsx)(_Box["default"], (0, _extends2["default"])({
    as: "button",
    sx: [buttonResetStyles, css]
  }, restProps, {
    ref: buttonRef
  }));
}

var ButtonRaw$ = _react["default"].forwardRef(function (props, ref) {
  return (0, _.jsx)(ButtonRaw_, (0, _extends2["default"])({
    buttonRef: ref
  }, props));
});

var _default = ButtonRaw$;
exports["default"] = _default;